export const educationRoutes = {
  root: "/education",
  courses: "/education/courses",
  course: (id: string) => `/education/course/${id}`,
  lesson: (id: string) => `/education/lesson/${id}`,
  checkpoint: (id: string) => `/education/checkpoint/${id}`,
  exam: (id: string) => `/education/exam/${id}`,
  examResult: (id: string) => `/education/exam/${id}/result`,
};
